module.exports = __webpack_public_path__ + "static/img/CourseClassifications.d09024b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CourseClassifications.png
// module id = 63
// module chunks = 1